export default __webpack_public_path__ + "fb701f760710f2f1023e1be3169d6125.png";